import { LineItemsTransfersActions, ResourceType } from 'src/models/query.model';
import { ActionMeta, ID, ManagerReqTableSections, VersionedPeriod } from 'src/models';
import { LineItemTransfer } from 'src/models/lineItem.model';

export interface RequestLineItemTransferProps {
  resource_id: ID;
  resource_type: ResourceType;
  section?: ManagerReqTableSections;
  period: VersionedPeriod;
  transfer: LineItemTransfer;
}

export const requestLineItemTransfer = (payload: RequestLineItemTransferProps, meta?: ActionMeta) => ({
  type: LineItemsTransfersActions.CREATE,
  payload: payload,
  meta,
});

export interface RequestLineItemForTransferProps {
  resource_id: ID;
  resource_type: ResourceType;
  line_item_id: ID;
  period: VersionedPeriod;
}

export const requestLineItemForTransfer = (payload: RequestLineItemForTransferProps, meta?: ActionMeta) => ({
  type: LineItemsTransfersActions.GET_LINE_ITEM,
  payload: payload,
  meta,
});

export const requestCreateLineItemForTransfer = (payload: Record<string, unknown>, meta?: ActionMeta) => ({
  type: LineItemsTransfersActions.CREATE_LINE_ITEM,
  payload: payload,
  meta,
});

export interface RequestLineItemForTransferAutoCompeteProps {
  resource_id: ID;
  resource_type: ResourceType;
  section?: ManagerReqTableSections;
  period: VersionedPeriod;
  query: string;
}

export const requestLineItemForTransferAutoCompete = (
  payload: RequestLineItemForTransferAutoCompeteProps,
  meta?: ActionMeta,
) => ({
  type: LineItemsTransfersActions.AUTOCOMPLETE,
  payload: payload,
  meta,
});
